import { render } from "./HelpEWBDelete.vue?vue&type=template&id=150d0b90"
import script from "./HelpEWBDelete.vue?vue&type=script&lang=js"
export * from "./HelpEWBDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__